




















































































import VueOptions from '@utils/VueOptions'
import ResourceBindSelector from '@ui/ResourceBindSelector/ResourceBindSelector'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'CreativeSpaceBindSelector'

  resources:
    audience_creative:
      resourceName: 'audience_creative'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreative.id/edit'
      fetch: false

    spaces:
      resourceName: 'space'
      slug: 'suppliers/:supplierId/spaces'
      params:
        scope: 'local'
        quick_list: true
        creative_id: ':audienceCreative.id' #This cannot be called audience_creative_id because it crahses the space list

  vue:
    props: ['audienceCreative', 'options']

    components: {
      ResourceBindSelector,
      LoadingIndicator,
    }

    data: ->
      selectedAudienceCreativeSpaces: []
      selectedSpaces: []

    computed:
      supplierId: -> @options?.supplierId || @$store.member.supplier.id
      audienceCreativeSpaceIds: -> @audienceCreative.space_ids
      audienceCreativeAvailabilityIds: -> @audienceCreative.availability_ids
      audienceCreativeSpaces: ->
        items = []
        for space in (@spaces || [])
          items.push space if space.id in @audienceCreativeSpaceIds
        items
      audienceCreativeSpacesTableData: ->
        @audienceCreativeSpaces.map((space) =>
          id: space.id
          data: space
          segment: space.segment
          size: space.size
          type: space.type
          availability_count: @audienceCreativeAvailabilitiesInSpaceCount(space)
        )

      spacesTableData: ->
        for space in (@spaces || [])
          continue if space.id in @audienceCreativeSpaceIds
          id: space.id
          data: space
          segment: space.segment
          size: space.size
          type: space.type

      optionsForBindSelector: ->
        title: 'Available Assets'
        description: 'List of opportunities for sponsors to activate their brand'
        addButtonText: 'Add New Asset'
        addExistingButtonText: 'Add Existing Asset'
        why: 'You can setup as many assets as you need, just add one asset at a time.'

    methods:
      hiAudienceCreativeSpacesSelectionChange: (spaces) ->
        @selectedAudienceCreativeSpaces = spaces
      hiAudienceCreativeSpacesRowClick: (row) ->
        @$refs.audienceCreativeSpacesTable.toggleRowSelection row
      hiUnbindAudienceCreativeSpace: (space) ->
        @unbindSpacesFromAudienceCreativeTrigger [space]
      hiUnbindSelectedAudienceCreativeSpaces: ->
        @unbindSpacesFromAudienceCreativeTrigger @selectedAudienceCreativeSpaces

      hiSpacesSelectionChange: (spaces) ->
        @selectedSpaces = spaces
      hiSpacesRowClick: (row) ->
        @$refs.spacesTable.toggleRowSelection row
      hiBindSpace: (space) ->
        @bindSpacesToAudienceCreativeTrigger [space]
      hiBindSelectedSpaces: ->
        @$refs.bindSelector.close()
        @bindSpacesToAudienceCreativeTrigger @selectedSpaces

      bindSpacesToAudienceCreativeTrigger: (spaces) ->
        @$emit 'bind'
        for spaceChunk in @chunkArray(spaces,1)
          for availabilityChunk in @chunkArray(@audienceCreative.availability_ids, 500)
            payload =
              space_ids: spaceChunk.map((s) => s.id)
              availability_ids: availabilityChunk
            @triggerResource 'audience_creative', 'bind_spaces', payload
      onAudienceCreativeBindSpaces: (_, item) ->
        @$refs.audienceCreativeSpacesTable?.clearSelection()
        @$emit 'change', item
        @fetch 'spaces'

      unbindSpacesFromAudienceCreativeTrigger: (spaces) ->
        @$emit 'bind'
        for spaceChunk in @chunkArray(spaces,5)
          payload =
            space_ids: spaceChunk.map((s) => s.id)
            availability_ids: @audienceCreative.availability_ids
          @triggerResource 'audience_creative', 'unbind_spaces', payload
      onAudienceCreativeUnbindSpaces: (_, item) ->
        @$emit 'change', item
        @fetch 'spaces'

      audienceCreativeAvailabilitiesInSpaceCount: (space) ->
        space.availability_ids.filter((id) => id in @audienceCreativeAvailabilityIds).length

export default VueOptions.vue settings
